import type { IGenreMinimal } from "../../../../types/models/genre.models.types";
import { useGetHttp } from "../../../../hooks/http/http.hook";

interface IResponse {
  genres: Array<IGenreMinimal>;
}

export function useGetSocialGenreHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/socials-genres",
  });
}
